import { ChangeType } from '../changes/change';
const descriptionChangeTypes = [
    ChangeType.FieldArgumentDescriptionChanged,
    ChangeType.DirectiveDescriptionChanged,
    ChangeType.DirectiveArgumentDescriptionChanged,
    ChangeType.EnumValueDescriptionChanged,
    ChangeType.FieldDescriptionChanged,
    ChangeType.FieldDescriptionAdded,
    ChangeType.FieldDescriptionRemoved,
    ChangeType.InputFieldDescriptionAdded,
    ChangeType.InputFieldDescriptionRemoved,
    ChangeType.InputFieldDescriptionChanged,
    ChangeType.TypeDescriptionChanged,
];
export const ignoreDescriptionChanges = ({ changes }) => {
    return changes.filter((change) => descriptionChangeTypes.indexOf(change.type) === -1);
};
//# sourceMappingURL=ignore-description-changes.js.map